import { BankAccountApprovalMode } from '@dealstack/shared/lib/generated';

export enum ENTITY_TABS {
	INDIVIDUAL = 'individual',
	INVESTMENT_VEHICLE = 'investment_vehicle',
}

export interface KycSetting {
	id: string;
	checked: boolean;
	disabled?: boolean;
}

export interface KycSettings {
	kycRequired: KycSetting;
	proofOfIdentityRequired: KycSetting;
	proofOfAddressRequired: KycSetting;
	proofOfInvestmentVehicleRequired: KycSetting;
	proofOfIdentityCertificationRequired: KycSetting;
	proofOfAddressCertificationRequired: KycSetting;
	proofOfInvestmentVehicleCertificationRequired: KycSetting;
	beneficialOwnershipRequired: KycSetting;
	sourceOfFundsRequired: KycSetting;
	pepRequired: KycSetting;
}

/** Programme policy for what happens to a bank account when it is submitted. */
export interface BankAccountApprovalSetting {
	value: BankAccountApprovalMode;
	disabled?: boolean;
}

export type CertificationSettingId = Extract<
	keyof KycSettings,
	| 'proofOfIdentityCertificationRequired'
	| 'proofOfAddressCertificationRequired'
	| 'proofOfInvestmentVehicleCertificationRequired'
>;

export interface KycSettingsType {
	settings: KycSettings;
	toggleSetting: (id: keyof KycSettings) => void;
	bankAccountApproval: BankAccountApprovalSetting;
	setBankAccountApproval: (value: BankAccountApprovalMode) => void;
	hasPermission: boolean;
	isLoading: boolean;
	certificationText: CertificationTextSource;
}

/** Where the certification wording is read from and saved to (programme or organisation tier). */
export interface CertificationTextSource {
	savedText: string | null;
	save: (text: string | null) => Promise<unknown>;
	isSaving: boolean;
}

export interface CertificationTextEditorState {
	value: string;
	setValue: (value: string) => void;
	resetToDefault: () => void;
	save: () => void;
	isDirty: boolean;
	isSaving: boolean;
	isValid: boolean;
}
